import { Form, Modal } from "antd";
import React from "react";
import { CreateAirSzzJournalDto } from "../../../api";
import { AirSzzJournalsColumns } from "../form/columns";

interface AirSzzJournalsFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateAirSzzJournal: (values: CreateAirSzzJournalDto) => void;
  organizationId?: string;
}

export const AirSzzJournalForm: React.FC<AirSzzJournalsFormProps> = ({ visible, setVisible, onCreateAirSzzJournal, organizationId }) => {
  const [form] = Form.useForm<CreateAirSzzJournalDto>();

  const onChange = (value: any, additional?: any) => {

    (Object.keys(form.getFieldsValue()) as (keyof CreateAirSzzJournalDto)[]).find((key) => {
      return form.getFieldsValue()[key] === value;
    });

  }

  return (
    <Modal width="60%" open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateAirSzzJournal}>
        {AirSzzJournalsColumns().map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {
              React.cloneElement(
                inputNode,
                {
                  onChange: onChange
                }
              )
            }
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
